import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SwModalframeComponent } from '../../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwGridTableComponent } from '../../../basic-components/sw-table/sw-grid-table/sw-grid-table.component';

@Component({
  selector: 'app-sw-approval-modal',
  templateUrl: './sw-approval-modal.component.html',
  styleUrls: ['./sw-approval-modal.component.css']
})
export class SwApprovalModalComponent implements OnInit {

  /**
   * 动态创建组件传入的参数
   */
  @Input() param: any;

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 是否展示左侧菜单
   * @ignore
   */
  showLeft:boolean = true  

  /**
   * 子流程常量配置模态框
   * @ignore
   */
  @ViewChild("approvalModal") approvalModal: SwModalframeComponent;

  /**
  * 常量配置中的选择流程定义下拉列表
  * @ignore
  */
 modelList:any[] = []  

  /**
  * 流程类型列表
  * @ignore
  */
 modelTypeList:any[] = []

 /**
  * 流程定义下拉树
  * @ignore
  */
 modelTreeList:any[] = [] 

 /**
  * 左侧选中的流程定义
  * @ignore
  */
 selectedModel:any
 
  /**
   * 常量配置模态框中编辑时,选中流程定义和对应选中的流程实体
   * @ignore
   */
  approvalInfo:any = {}  
  
  /**
   * 模态框中的选中的审批单列表
   * @ignore
   */
  approvalModelList:any[] = []  
  
  /**
   * 常量配置中的流程实体下拉列表
   * @ignore
   */
  procInstanceList:any[] = []  
  
  /**
   * 右侧的表格
   * @ignore
   */
  @ViewChild("swtable") swtable :SwGridTableComponent;

  /**
   * 模态框确认按钮状态,是否置灰,默认置灰
   * @ignore
   */
  disabled:boolean = true

  constructor(
    
    private http: SwHttpClientService, //http请求
    public box: SwMassageBoxService, //提示信息
    private dictionaryService:DictionaryService,
  ) { }

  ngOnInit() {
    //从字典项中获取发起流程的类型
    this.modelTypeList = this.dictionaryService.getDictionaryValueOrName('SYS_LCTYPE_OPTION')  
    //所有的流程类型的pid都为 0 , 都是主节点
    this.modelTypeList.map(item=>item.pid = '0')
    //获取流程定义列表
    this.getmodelList()
    //审核组件传递进来的数据要在表格中完成回显,所以要处理为 approvalInfo对象.
    this.approvalModelList = JSON.parse(JSON.stringify(this.param.approvalPageList))
    if(this.approvalModelList.length){
      //此时有回显的数据,确认按钮是可以点击的
      this.disabled = false
      this.approvalModelList.forEach(item=>{
        if(this.approvalInfo[item.keyWord]){
          this.approvalInfo[item.keyWord].push(item)
        } else {
          this.approvalInfo[item.keyWord] = []
          this.approvalInfo[item.keyWord].push(item)
        }
      })
    }

    //初始化的时候,左侧列表没有选中项,查询流程实体列表
    let param = {
      keyWord : null,
      procInstId : null
    }
    this.http.Post(environment.activitiWebAPI+`swActivitiTaskRecord/querytLastRecord?keyWord=${param.keyWord}`,{}).subscribe(res=>{
      if(res && res.code == 200){
        this.procInstanceList = res.data 
      }
    })
  }

  ngAfterViewInit(): void {
    if(this.approvalModelList.length){
      let ids = this.approvalModelList.map(item=>item.procInstId)
      //右侧列表出现后,进行回显
      setTimeout(() => {
        this.swtable.selectTableArray(ids,'procInstId')
      }, 100);
    }
  }

  /**
   * 获取流程定义树列表
   * @ignore
   */
  getmodelList(){
    let param={
      'entity':{},
      'param':{pageSize:0}
    };
    this.http.Post(environment.activitiWebAPI+`swActivitiModel/queryPageList`, param).subscribe(res=>{
      if(res && res.code == 200){
        //获取到对应的流程定义,将其中的流程类型作为自己的pid , 形成树数据
        let aa = []
        res.data.records.forEach(v => {
          aa.push({id:v.keyWord, text:v.flowName,pid:v.modelType})
        });
        //将之前查到的所有流程类型数组和现在处理好的所有流程定义数组合并成一个新数组, 成为 左侧 sw-tree 的数据源
        this.modelTreeList = this.modelTypeList.concat(aa)
      }
    })
  }

  /**
   * 选中左侧树之后,查询对应的流程实体
   * @ignore
   */
  onVotedModel(event){
    //确认选中的流程定义
    this.selectedModel = event
    //查询流程实体列表
    let param = {
      keyWord : event.key, 
      procInstId : null
    }
    this.http.Post(environment.activitiWebAPI+`swActivitiTaskRecord/querytLastRecord?keyWord=${param.keyWord}`,{}).subscribe(res=>{
      if(res && res.code == 200){
        this.procInstanceList = res.data
        if(!this.approvalInfo[event.key]){
          //如果之前没有点击过该节点,就加上该属性,其值为 []
          this.approvalInfo[event.key] = []
        } else {
          //如果之前点击过该节点,就回显已经选中过的id
          if(this.procInstanceList.length && this.approvalInfo[event.key] && this.approvalInfo[event.key][length]){
            let ids = this.approvalInfo[event.key].map(item=>item.procInstId)
            //右侧列表出现后,进行回显
            setTimeout(() => {
              this.swtable.selectTableArray(ids,'procInstId')
            }, 100);
          }
        }
      }
    })
  }

  /**
   * 选中右侧表格中的数据
   * @ignore
   */
  outSelectData(event){
    if(event.length){
      //此时选中的流程实体不为0, 表示可以点击确认按钮
      this.disabled = false
    } else{
      //此时选中的流程实体为0, 表示不能击确认按钮
      this.disabled = true
    }
    // 将多选列表中选中的数据赋值给 approvalInfo 对象中对应的值
    this.approvalInfo[this.selectedModel.key] = event
  }

   /**
   * 点击模态框常量配置的确定按钮
   * @ignore
   */
  sure(){
    if(!this.disabled){
      //处理要传出的数据
      this.approvalModelList = []
      //遍历 approvalInfo对象 , 将其中每个属性的值都放在 approvalModelList 中去
      for (const key in this.approvalInfo) {
        let list = this.approvalInfo[key]
        this.approvalModelList = this.approvalModelList.concat(list)
      }
      this.approvalModal.toggle()   //关闭模态框
      //将选中的数据传递给父组件,执行回调,回调中参数就是抛出的数据
      this.callback.emit(this.approvalModelList);
    }else {
      this.box.danger('请选择流程实体')
    }
   
  }

  /**
   * 关闭常量配置模态框
   * @ignore
   */
  closeApproval(){
    this.approvalModal.toggle()   //关闭模态框
    this.callback.emit(false);  //抛出false,只销毁组件
  }

  /**
   * 隐藏左边面板
   * @ignore
   */
  showStyle(data) {
    this.showLeft=!data;
  }

}
